import { Field, useFormikContext } from "formik";
import React, { useEffect, useState } from "react";
import { StyledContainer, StyledSuggestions } from "./address-autocomplete.styles";

const GATSBY_GETADDRESS_API_KEY = process.env.GATSBY_GETADDRESS_API_KEY as string;

export const AddressAutocomplete = ({id,name,placeholder,postcodeField,cityField}) => {
  const [inputValue, setInputValue] = useState('');
  const [suggestions, setSuggestions] = useState<{id,address}[]>([]);
  const [isOpen, setIsOpen] = useState(false);

  const {setFieldValue, values} = useFormikContext();

  useEffect(() => {
    const fetchSuggestions = async () => {
      console.log("fetchSuggestions",inputValue)

      if(!inputValue || inputValue.length < 3) {
        setSuggestions([]);
        return;
      }

      try {
        const response = await fetch(`https://api.getaddress.io/autocomplete/${inputValue}?api-key=${GATSBY_GETADDRESS_API_KEY}`);

        console.log(response);
        
        if (!response.ok) {
          throw new Error(response.statusText);
        }

        const {suggestions} = await response.json();
        setSuggestions(suggestions);
      } catch (err) {
        console.error('Autocomplete fetch failed:', err);
        setSuggestions([]);
      }
    };

    

    fetchSuggestions();

  }, [inputValue]);

  

  const handleSelection = (placeId) => async () => {

    console.log('Selected suggestion:', placeId);

    setIsOpen(false);

    if(id){
      try {
        const response = await fetch(`https://api.getAddress.io/get/${placeId}?api-key=${GATSBY_GETADDRESS_API_KEY}`);
        
        if (!response.ok) {
          throw new Error(response.statusText);
        }

        const address = await response.json();
        const streetAddress = [address.line_1, address.line_2, address.line_3, address.line_4, address.locality].filter(Boolean).join(", ");
        const postcode = address.postcode;
        const city = address.town_or_city;

        setInputValue(streetAddress);
        setFieldValue(id, streetAddress);

        if(postcodeField) {
          setFieldValue(postcodeField, postcode);
        }

        if(cityField) {
          setFieldValue(cityField, city);
        }

      } catch (err) {
        console.error('Autocomplete fetch failed:', err);
      }
    }
  };

  return (
    <StyledContainer>
      <Field id={id} type="text" as="input" autoComplete="off" name={name} placeholder={placeholder} value={inputValue} onBlur={() => setIsOpen(false)} onFocus={() => setIsOpen(true)} onChange={(e) => setInputValue(e.target.value)} />
      <StyledSuggestions $open={isOpen && suggestions.length > 0}>
        {suggestions.map((suggestion) => (
          <li key={suggestion.id} onMouseDown={handleSelection(suggestion.id)}>
            {suggestion.address}
          </li>
        ))}
      </StyledSuggestions>
    </StyledContainer>
  );
};

